var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightIcon = function SvgRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "right-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.89,
    height: 15.003
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.414.421a1.423 1.423 0 0 0 0 2.007l5.038 5.109-5.038 5.038a1.424 1.424 0 1 0 2.021 2.007l6.034-6.034a1.423 1.423 0 0 0 0-2.021L2.435.421a1.423 1.423 0 0 0-2.021 0Z"
  })));
};
export default SvgRightIcon;